import signalR = require("@microsoft/signalr");
import { app } from "../Frame/App";

export class ReportConnectionManager {

    onlineConnection: signalR.HubConnection = null;
    private reportId: number;
    private tabId: string;

    getSignalRConnection = () => {
        return new signalR.HubConnectionBuilder()
            .withUrl(app.resolveUrl("~/ReportHub"))
            .withAutomaticReconnect()
            .build();
    }

    public init = () => {
        this.onlineConnection = this.getSignalRConnection();
        this.onlineConnection.start();

        // The correct reportId will be set when a report is selected on the UI
        this.reportId = 0;

        // Set page beforeUnload event to catch if the browser window is closed, the user navigates elsewhere or an error occurs
        window.addEventListener("beforeunload", (event: Event) => {
            this.removeConnectionAndClose();
        });
    }

    public isInitialized = (): boolean => {
        if (this.reportId && this.tabId) return true;
    }

    public setReport = (reportId: number, tabId: string) => {
        if (this.reportId != 0) {
            // remove report connection for the previously shown report
            if (this.onlineConnection?.state == signalR.HubConnectionState.Connected) {
                this.onlineConnection.invoke("RemoveAndDiospose", this.reportId, this.tabId)
                    .then(() => {
                        // after removing the last connection, set the new reportId.
                        this.reportId = reportId;
                        this.tabId = tabId;
                    });
            }
        } else {
            this.reportId = reportId;
            this.tabId = tabId;
        }

    }

    public removeConnection = () => {
        if (this.onlineConnection?.state == signalR.HubConnectionState.Connected) {
            this.onlineConnection.invoke("RemoveAndDiospose", this.reportId, this.tabId);
        }
    }

    public removeConnectionAndClose = () => {
        if (this.onlineConnection?.state == signalR.HubConnectionState.Connected) {
            this.onlineConnection.invoke("RemoveAndDiospose", this.reportId, this.tabId)
                .then(
                    () => {
                        console.log("stopping signalR connection after report connection was closed...");
                        return this.onlineConnection.stop();
                    },
                    (reason) => {
                        console.log(`Error calling RemoveAndDiospose.\n${reason}`);
                    });
        }
    }

    public manualRemoveConnection = () => {
        $.ajax({
            url: app.resolveUrl(`~/api/StimulsoftReports/manualRemoveReportConnection/${this.reportId}/${this.tabId}`),
            method: "POST",
            success: (response) => {
                console.log("Report Connection remove success");
            },
            error: (err) => {
                console.log(err);
            }
        });
    }
}